// ./src/contexts/ThemeContext/ThemeContext.tsx
import React, { useMemo } from "react";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { ModalsProvider } from "@mantine/modals";
import { brandCssVariablesResolver, getBrandTheme } from "@em/ui";
import { brandStyle } from "@/config/branding";

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  // Active brand picks its local theme variant (festive vs business). The resolver puts the variant's canvas into
  // the global CSS (`--em-app-canvas` → `--ce-bg-primary`, the body background).
  const theme = useMemo(() => getBrandTheme(brandStyle.themeVariant), []);

  return (
    <MantineProvider theme={theme} cssVariablesResolver={brandCssVariablesResolver}>
      <Notifications />
      <ModalsProvider>{children}</ModalsProvider>
    </MantineProvider>
  );
};
